import React from 'react'
import authRoute from './authRoute'
import { APP_PREFIX_PATH } from 'constants/route.constant'
import { ADMIN, USER } from 'constants/roles.constant'


export const publicRoutes = [...authRoute]
export const pagesRoutes = [{
    key: 'onboarding',
    path: '/onboarding/survey/:step',
    component: React.lazy(() => import('views/onboarding')),
    authority: [],
    meta: {
        layout: 'blank',
       
    },
},]

export const protectedRoutes = [
    {
        key: 'home',
        path: '/dashboard/default',
        component: React.lazy(() => import('views/MySpace')),
        authority: [],
    }, 
    {
        key: 'products',
        path: '/catalog',
        component: React.lazy(() => import('views/catalog')),
        authority: [],
    },
    {
        key: 'products',
        path: '/dashboard/products',
        component: React.lazy(() => import('views/ProductList')),
        authority: [],
    },
    {
        key: 'productinfo',
        path: '/dashboard/product-view/:id',
        component: React.lazy(() => import('views/ProductView/viewProduct')),
        authority: [],
    },
    {
        key: 'productinfo',
        path: '/dashboard/product-edit/:id',
        component: React.lazy(() => import('views/ProductView')),
        authority: [],
    },
    {
        key: 'designproduct',
        path: '/dashboard/product/design',
        component: React.lazy(() => import('views/ProductDesigner')),
        authority: [],
    },
    {
        key: 'designproducts',
        path: '/dashboard/product/design/:start',
        component: React.lazy(() => import('views/ProductDesigner')),
        authority: [],
    },
    {
        key: 'designproducts',
        path: '/dashboard/info/:id',
        component: React.lazy(() => import('views/ProductInfo')),
        authority: [],
    },
    {
        key: 'create-design',
        path: '/dashboard/product/create-design/:id',
        component: React.lazy(() => import('views/ProductDesigner/CreateDesign')),
        authority: [],
        meta: {
            footer: false
        }
    },
    {
        key: 'wooconnect-callback',
        path: '/dashboard/integration-callback/woocommerce/connect',
        component: React.lazy(() => import('views/Stores/WooIntegration')),
        authority: [],
        meta: {
            footer: false
        }
    },
    {
        key: 'wooconnect-callback',
        path: '/dashboard/woocommerce/callback',
        component: React.lazy(() => import('views/Stores/WooIntegrationCallback')),
        authority: [],
        meta: {
            footer: false
        }
    },
    //integration-callback/woocommerce/connect /dashboard/woocommerce/callback
    {
        key: 'orders',
        path: '/dashboard/orders',
        component: React.lazy(() => import('views/OrderList')),
        authority: [],
    },
    {
        key: 'stores',
        path: '/dashboard/stores',
        component: React.lazy(() => import('views/Stores')),
        authority: [],
    },
    {
        key: 'art-library',
        path: '/dashboard/art-library',
        component: React.lazy(() => import('views/artlab/')),
        authority: [],
    },
    {
        key: 'stores',
        path: '/dashboard/stores/connect',
        component: React.lazy(() => import('views/Stores/ConnectStore')),
        authority: [],
    },
    {
        key: 'stores-auth',
        path: '/dashboard/stores/shopify-auth',
        component: React.lazy(() => import('views/Stores/ShopifyAuth')),
        authority: [],
    },
    {
        key: 'stores-auth',
        path: '/dashboard/stores/shopify-auth-callback',
        component: React.lazy(() => import('views/Stores/ShopifyAuthCallback')),
        authority: [],
    },
    {
        key: 'stores-auth',
        path: '/dashboard/stores/wix-auth-callback',
        component: React.lazy(() => import('views/Stores/WixAuthCallback')),
        authority: [],
    },
    {
        key: 'stores-auth-tiktok',
        path: '/dashboard/stores/tiktok-auth-callback',
        component: React.lazy(() => import('views/Stores/TiktokAuthCallback')),
        authority: [],
    },
    {
        key: 'stores',
        path: '/dashboard/:action/:type',
        component: React.lazy(() => import('views/Stores/CreateConnection')),
        authority: [],
    },
    {
        key: 'appsAccount.settings',
        path: `${APP_PREFIX_PATH}/account/settings/:tab`,
        component: React.lazy(() => import('views/account/Settings')),
        authority: [ADMIN, USER],
        meta: {
            header: 'Settings',
            headerContainer: true,
        },
    },
    {
        key: 'appsAccount.shipping',
        path: `${APP_PREFIX_PATH}/account/orders-shipping/:tab`,
        component: React.lazy(() => import('views/account/OrdersShipping')),
        authority: [ADMIN, USER],
        meta: {
            header: 'Settings',
            headerContainer: true,
        },
    },
    {
        key: 'collapseMenu.item1',
        path: '/collapse-menu-item-view-1',
        component: React.lazy(() => import('views/account/Settings')),
        authority: [],
    },
    {
        key: 'collapseMenu.item3',
        path: '/dashboard/account/activity-log',
        component: React.lazy(() => import('views/account/KycForm')),
        authority: [],
    },
    {
        key: 'collapseMenu.item2',
        path: `${APP_PREFIX_PATH}/account/billing/:tab`,
        component: React.lazy(() => import('views/account/BillingSettings')),
        authority: [],
    },
    {
        key: 'help.list',
        path: `${APP_PREFIX_PATH}/help`,
        component: React.lazy(() => import('views/help')),
        authority: [ADMIN, USER],
        meta: {
            header: 'Help',
            headerContainer: true,
        },
    },
    {
        key: 'help.tickets',
        path: `${APP_PREFIX_PATH}/help/tickets`,
        component: React.lazy(() => import('views/help/tickets')),
        authority: [ADMIN, USER],
        meta: {
            header: 'Tickets',
            headerContainer: true,
        },
    },
    {
        key: 'odrder.create',
        path: '/dashboard/order/:state',
        component: React.lazy(() => import('views/OrderList/NewOrder')),
        authority: [ADMIN, USER],
        meta: {
           
        },
    },
    {
        key: 'team.setup',
        path: '/dashboard/team/shop',
        component: React.lazy(() => import('views/team/ShopSetup')),
        authority: [ADMIN, USER],
        meta: {
           
        },
    },
    {
        key: 'team.members',
        path: '/dashboard/team/members',
        component: React.lazy(() => import('views/team/TeamMembers')),
        authority: [ADMIN, USER],
        meta: {
           
        },
    },
    {
        key: 'team.orders',
        path: '/dashboard/team/orders',
        component: React.lazy(() => import('views/team/TeamOrders')),
        authority: [ADMIN, USER],
        meta: {
           
        },
    },
    {
        key: 'team.payouts',
        path: '/dashboard/team/payouts',
        component: React.lazy(() => import('views/team/TeamPayouts')),
        authority: [ADMIN, USER],
        meta: {
           
        },
    },
    
]
